export default "__VITE_ASSET__B5Pe4Nte__"